import { render, staticRenderFns } from "./FormSelect2.vue?vue&type=template&id=94fc676e"
import script from "./FormSelect2.vue?vue&type=script&lang=js"
export * from "./FormSelect2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports